import { env } from '@2l/utils'
import { metrics } from '@opentelemetry/api'
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http'
import { resourceFromAttributes } from '@opentelemetry/resources'
import {
  AggregationType,
  InstrumentType,
  MeterProvider,
  PeriodicExportingMetricReader
} from '@opentelemetry/sdk-metrics'

import pkg from '../../../package.json'
import { SERVICE_NAME } from './constants'

const appEnvironment: string = __ENVIRONMENT__ || 'production'
const appVersion =
  appEnvironment === 'production' ? pkg.version : env('VERSION', pkg.version)

const OTEL_METRICS_ENDPOINT =
  appEnvironment === 'production'
    ? 'https://telemetry.appewa.com/api/v1/metrics'
    : 'https://telemetry.dev.appewa.com/api/v1/metrics'

const resource = resourceFromAttributes({
  'service.name': SERVICE_NAME,
  'service.version': appVersion
})

const exporter = new OTLPMetricExporter({
  url: OTEL_METRICS_ENDPOINT
})

const reader = new PeriodicExportingMetricReader({
  exporter,
  exportIntervalMillis: 30000,
  exportTimeoutMillis: 10000
})

const meterProvider = new MeterProvider({
  resource,
  views: [
    {
      instrumentName: 'webvitals.lcp',
      instrumentType: InstrumentType.HISTOGRAM,
      instrumentUnit: 's',
      aggregation: {
        type: AggregationType.EXPLICIT_BUCKET_HISTOGRAM,
        options: {
          boundaries: [800, 1200, 1600, 2400, 4000, 6000]
        }
      }
    },
    {
      instrumentName: 'webvitals.inp',
      instrumentType: InstrumentType.HISTOGRAM,
      instrumentUnit: 'ms',
      aggregation: {
        type: AggregationType.EXPLICIT_BUCKET_HISTOGRAM,
        options: {
          boundaries: [100, 200, 300, 500, 800, 1200]
        }
      }
    },
    {
      instrumentName: 'webvitals.cls',
      instrumentType: InstrumentType.HISTOGRAM,
      instrumentUnit: 's',
      aggregation: {
        type: AggregationType.EXPLICIT_BUCKET_HISTOGRAM,
        options: {
          boundaries: [0.01, 0.05, 0.1, 0.25, 0.5]
        }
      }
    },
    {
      instrumentName: 'webvitals.ttfb',
      instrumentType: InstrumentType.HISTOGRAM,
      instrumentUnit: 's',
      aggregation: {
        type: AggregationType.EXPLICIT_BUCKET_HISTOGRAM,
        options: {
          boundaries: [100, 200, 400, 800, 1600, 3000]
        }
      }
    },
    {
      instrumentName: 'webvitals.fcp',
      instrumentType: InstrumentType.HISTOGRAM,
      instrumentUnit: 's',
      aggregation: {
        type: AggregationType.EXPLICIT_BUCKET_HISTOGRAM,
        options: {
          boundaries: [900, 1500, 2000, 3000, 5000]
        }
      }
    }
  ],
  readers: [reader]
})

metrics.setGlobalMeterProvider(meterProvider)
export const meter = metrics.getMeter(SERVICE_NAME)
